const ROBOTO_MONO_SAMPLES = [
  '400 1rem "Roboto Mono"',
  '500 1rem "Roboto Mono"',
  '700 1rem "Roboto Mono"',
];

/** Wait until bundled Roboto Mono faces are loaded (not just document.fonts.ready). */
export function waitForAppFonts() {
  if (!document.fonts?.load) {
    return Promise.resolve();
  }

  return Promise.all(
    ROBOTO_MONO_SAMPLES.map((sample) =>
      document.fonts.load(sample).catch(() => undefined),
    ),
  ).then(() => document.fonts.ready);
}
